
const TargetAudienceSection = () => {
  const targetProfiles = [
    {
      icon: 'ri-calculator-line',
      title: 'Contadores',
      description: 'Que desejam ampliar sua atuação e se especializar na nova legislação tributária'
    },
    {
      icon: 'ri-file-chart-line',
      title: 'Analistas Fiscais',
      description: 'Que precisam se atualizar com as mudanças da reforma tributária'
    },
    {
      icon: 'ri-briefcase-line',
      title: 'Gestores Tributários',
      description: 'Que buscam visão estratégica para implementar as novas regras'
    },
    {
      icon: 'ri-building-line',
      title: 'Empresários',
      description: 'Que querem entender o impacto das mudanças em seus negócios'
    },
    {
      icon: 'ri-graduation-cap-line',
      title: 'Estudantes',
      description: 'De contabilidade e direito que desejam se especializar na área tributária'
    },
    {
      icon: 'ri-user-star-line',
      title: 'Consultores',
      description: 'Que prestam serviços tributários e querem se manter atualizados'
    }
  ];

  return (
    <section id="target-audience" className="py-20 bg-gray-50">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-6">
            Saia do papel de espectador e descubra como transformar mudanças legais em faturamento real, contratos estratégicos e autoridade consolidada.
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Desenvolvemos este conteúdo especificamente para profissionais que precisam dominar 
            as mudanças da reforma tributária e aplicá-las no dia a dia
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 max-w-6xl mx-auto">
          {targetProfiles.map((profile, index) => (
            <div 
              key={index}
              className="bg-white rounded-xl p-6 shadow-lg hover:shadow-xl transition-all duration-300 transform hover:-translate-y-2 border border-gray-100"
            >
              <div className="w-16 h-16 bg-blue-800 rounded-xl flex items-center justify-center mb-4 mx-auto">
                <i className={`${profile.icon} text-white text-2xl`}></i>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-3 text-center">
                {profile.title}
              </h3>
              <p className="text-gray-600 text-center leading-relaxed">
                {profile.description}
              </p>
            </div>
          ))}
        </div>

        <div className="text-center mt-12">
          <div className="bg-orange-50 border border-orange-200 rounded-lg p-6 max-w-2xl mx-auto">
            <div className="flex items-center justify-center mb-4">
              <div className="w-12 h-12 bg-orange-500 rounded-lg flex items-center justify-center">
                <i className="ri-alarm-warning-line text-white text-xl"></i>
              </div>
            </div>
            <p className="text-orange-800 font-semibold text-lg">
              Vagas limitadas - Garanta sua participação agora!
            </p>
            <p className="text-orange-600 mt-2">
              Turmas reduzidas para garantir qualidade no aprendizado
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TargetAudienceSection;
